import "./index.scss";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import { useHistory } from "react-router-dom";
import Button from "../../Button/Button";
import * as api from "../../api";
import { uuid } from "uuidv4";
import {
  CreateAppointmentParams,
  getAvailabilityForAppointment,
  patchAppointment,
  postAppointment,
} from "../../api/appointmentApi";
import { RawAvailablity } from "../../models/Appointment";
import {
  getContractorName,
  getPrefferenceNumber,
  getReferenceNumber,
  saveAvailabilityResponse,
} from "../../ducks/redux/actions/getAddress";
import { formatDateWithFullMonthWeekInLetters, isNullOrUndefined } from "../../utils/formatting";
import { showMenuTabs, userChosenPropertyType, showFooter, setWorkOrderApiFailureMessage, calendarPageIndex, originalRepairAppointmentData, dmcRepairAppointmentData, dmcRepairSelectedSlotData, originalRepairSelectedSlotData, originalRepairAppointmentWillNotBeCreated, dmcRepairAppointmentWillNotBeCreated } from "../../ducks/redux/actions/userChoices";
import { RescheduleAppointmentModel } from "../../models/RescheduleAppointment";
import ExitModal from "../Modal/ExitModal";
import { isIPhone, isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import HeaderJourney from "../../storybook/Header/HeaderJourney"
import Message from "../../storybook/Message";
import BackModal from "../Modal/BackModal";
import { googleAnalyticsTracking } from "../../utils/Analytics";
import Modal from "../Modal";
import { saveSelectedSlotDate, setTriageRepair, comingFromRepairJourneySuccess, savingCalenderIndex, savingcalenderTrackValue, savingDmcCalenderTrackValue, savingDmcCalenderIndex } from "../../ducks/redux/actions/FinancialReferral";
import {
  CASE_ACTIVITIES_DATA
} from "../../ducks/redux/actionTypes";
import { CaseActionItem } from "../../models/Case/CaseActionItem"
import "../LoaderPage/index.scss";
import { detectMobile } from "../../utils/formatting";
import moment from "moment";

const AppointmentScheduler: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const isMobile = detectMobile();
  const range = 5;
  const [track, setTrack] = useState(0);
  const [error, setError] = useState("");
  const [selectedSlot, setSelectedSlot] = React.useState<any>(null);
  const history = useHistory();
  const [schedules, setSchedules] = useState<any>({
    availabilities: null,
  });
  const [buttondisable, setButtonDisable] = React.useState(true);
  const [caseActivities, setcaseActivities] = React.useState<any>(null);
  let reasonOutsideSla = "";
  let [isRescheduleAppointment, setIsRescheduleAppointment] = React.useState(false);
  const [isRescheduleApiDown, setErrorForRescheduleApiDown] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [popup, setPopup] = useState(false)
  const getNoSuitableSelectedSlot = () => sessionStorage.getItem("noSutaibleSelectedSlot") ?? "true";
  const setNoSuitableSelectedSlot = (value: boolean) => sessionStorage.setItem("noSutaibleSelectedSlot", value ? "true" : "false");

  const availabilityData = useSelector(
    (state: any) => state.addresses?.contractorAvailabilityResponse
  );
  const customerID = useSelector((state: any) => state.addresses?.customerid);
  const isPreferenceAppointment = useSelector(
    (state: any) => state.addresses?.preferenceno
  );
  const referenceNumberCode = useSelector(
    (state: any) => state.addresses?.referenceno
  );
  const workOrderObject = useSelector(
    (state: any) => state?.addresses?.workOrderRepair
  );
  const repairHistoryData = useSelector(
    (state: any) => state.historicRepairReducer?.repairHistoryData
  );
  const determinedcontractordetails = useSelector(
    (state: any) => state.addresses?.determinedcontractordetails
  );
  const phone = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenContactPhone
  );
  const name = useSelector(
    (state: any) => state.userChoicesReducer?.userChosenContactName
  );
  const loggedInStatus = useSelector(
    (state: any) => state?.userChoicesReducer?.loginStatus
  );
  const userGetRepairDataValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userGetRepairData
  );
  const originalRepairAppointmentValue = useSelector(
    (state: any) => state?.userChoicesReducer?.originalRepairAppointmentData
  );
  const dmcRepairAppointmentValue = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairAppointmentData
  );
  const calendarPageIndexValue = useSelector(
    (state: any) => state?.userChoicesReducer?.calendarPageIndex
  );
  const originalRepairSelectedSlotValue = useSelector(
    (state: any) => state?.userChoicesReducer?.originalRepairSelectedSlot
  );
  const dmcRepairSelectedSlotValue = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairSelectedSlot
  );
  const isOriginalRepairAppointmentWillNotBeCreated = useSelector(
    (state: any) => state?.userChoicesReducer?.originalRepairAppointmentWillNotBeCreated
  );
  const isDmcRepairAppointmentWillNotBeCreated = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairAppointmentWillNotBeCreated
  );
  const caseIdentifiers = useSelector(
    (state: any) => state?.caseCreationReducer?.caseIdentifier
  )
  const dmcWOObject = useSelector(
    (state: any) => state.addresses.dmcWorkOrderRepair
  );
  const calenderIndexValue = useSelector(
    (state: any) => state.financialReferralReducer?.calenderIndex
  );
  const calenderTrackValue = useSelector(
    (state: any) => state.financialReferralReducer?.calenderTrackNumber
  );

  const dmcCalenderIndexValue = useSelector(
    (state: any) => state.financialReferralReducer?.dmcCalenderIndex
  );
  const dmcCalenderTrackNumberValue = useSelector(
    (state: any) => state.financialReferralReducer?.dmcCalenderTrackNumber
  );

  let [configuration_Timeout] = useState("")

  const getTimeFromAppConfigure = async () => {
    try {
      const response = await api.GetAppConfigToggleValue("MyPeabody:AvailabilityWaitTime");
      configuration_Timeout = response?.value
    } catch (error) {
      console.error("Failed to fetch get app config time:", error);
    }
  }

  useEffect(() => {
    const initialize = async () => {
      await getTimeFromAppConfigure();
      dispatch(showMenuTabs(false));
      dispatch(showFooter(false));
      dispatch(getPrefferenceNumber(true));
      GetAppointmentAvailability();
      googleAnalyticsTracking(customerID);
    };
    initialize();
  }, []);

  const [calendarSelect, setCalendarSelect]: any = useState([[]]);
  const [markSelectedSlot, setMarkSelectedSlot]: any = useState({
    objects: [[{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }],
    [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }],
    [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }],
    [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }],
    [{ id: 0 }, { id: 1 }, { id: 2 }, { id: 3 }]]
  })

  useEffect(() => {
    setSchedules({
      availabilities: availabilityData,
    });
    if (calendarPageIndexValue === 1) {
      if (!isNullOrUndefined(dmcRepairSelectedSlotValue)) {
        setButtonDisable(false);
        setSelectedSlot(dmcRepairSelectedSlotValue)
        dispatch(dmcRepairSelectedSlotData(dmcRepairSelectedSlotValue));
      } else {
        setButtonDisable(true);
      }
    }
    else {
      if (!isNullOrUndefined(originalRepairSelectedSlotValue)) {
        setButtonDisable(false);
        dispatch(originalRepairSelectedSlotData(originalRepairSelectedSlotValue));
      }
    }
  }, [availabilityData]);

  const setDispatchSelectedSlot = (data: any) => {
    if (calendarPageIndexValue === 1) {
      dispatch(dmcRepairSelectedSlotData(data));
      dispatch(savingDmcCalenderTrackValue(data.track.toString()));
    }
    else {
      dispatch(originalRepairSelectedSlotData(data));
      dispatch(savingcalenderTrackValue(data.track.toString()));
      setNoSuitableSelectedSlot(false);
    }
  }

  const tableActive = (dateIndex: number, scheduleIndex: number, data: any) => {
    const value = [dateIndex, scheduleIndex]
    if (calendarPageIndexValue !== 1) {
      dispatch(savingCalenderIndex(value));
    }
    else if (calendarPageIndexValue === 1) {
      dispatch(savingDmcCalenderIndex(value))
    }
    for (let i = 0; i <= 4; i++) {
      for (let j = 0; j < 5; j++) {
        if (i == dateIndex && j == scheduleIndex) {
          setCalendarSelect(markSelectedSlot.objects[dateIndex][scheduleIndex]);
          if (calendarPageIndexValue === 1 && !isNullOrUndefined(dmcRepairSelectedSlotValue)) {
            setButtonDisable(false);
          }
          if (calendarPageIndexValue != 1 && !isNullOrUndefined(originalRepairSelectedSlotValue)) {
            setButtonDisable(false);
          }
        }
      }
    }
  }
  const calBackground = (dateIndex: number, scheduleIndex: number) => {
    if (markSelectedSlot.objects[dateIndex][scheduleIndex] == calendarSelect) {
      return "click-calander sc-sched-slots cal-btn color-new error-span-remove";
    }
    else {
      return "sc-sched-slots cal-btn color-new error-span-remove"
    }
  }

  const changeRange = (back: boolean) => {
    setCalendarSelect(null);
    setSelectedSlot(null)
    setButtonDisable(true)
    if (calendarPageIndexValue === 1) {
      dispatch(savingDmcCalenderTrackValue(""));
    }
    else {
      dispatch(savingcalenderTrackValue(""));
    }

    const maxLength = schedules.availabilities[0].slots.length;
    if (back) {
      const nextTrack = track - range;
      nextTrack < 0 ? setTrack(0) : setTrack(nextTrack);
      if (calendarPageIndexValue !== 1) {
        dispatch(originalRepairSelectedSlotData(null));
      }
      else if (calendarPageIndexValue === 1) {
        dispatch(dmcRepairSelectedSlotData(null))
      }
    } else {
      const nextTrack = track + range;
      if (nextTrack <= maxLength) setTrack(nextTrack);
      if (calendarPageIndexValue !== 1) {
        dispatch(originalRepairSelectedSlotData(null));
      }
      else if (calendarPageIndexValue === 1) {
        dispatch(dmcRepairSelectedSlotData(null))
      }
    }
  };

  const [isLoading, setIsLoading] = React.useState(true);
  const [isNextLoading, setIsNextLoading] = useState(false);
  const { t } = useTranslation();
  const isDMCEnabledtoggleValue = useSelector(
    (state: any) => state?.addresses?.isDMCEnabledtoggleValue
  );
  const msgError = t("SSR062");

  const [width, setWidth] = useState<number>(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  } useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);
  const isMobileDevice = width <= 768;

  const callPageHandler = () => {
    if (calendarPageIndexValue === 1) {
      if (isNullOrUndefined(dmcRepairSelectedSlotValue)) {
        setError(msgError);
      }
      else {
        sessionStorage.removeItem("noSutaibleSelectedSlot");
        createAppointmentonFinalStep();
      }
    }
    else {
      if (isNullOrUndefined(originalRepairSelectedSlotValue)) {
        setError(msgError);
      }
      else {
        if (isDmcRepairAppointmentWillNotBeCreated) {
          createAppointmentonFinalStep();
        }
        else {
          dispatch(calendarPageIndex(1));
          props.history.push("/appointmentscheduler");
          window.location.reload();
        }
      }
    }
  };

  const callPageHandlerForSingleWO = () => {
    if (
      typeof selectedSlot === "undefined" ||
      selectedSlot === null ||
      selectedSlot === ""
    ) {
      setError(msgError);
    }
    else {
      createAppointmentonFinalStep();
    }
  };

  const callReturnToRepairPageHandler = () => {
    props.history.push("/historicRepairs");
  };
  const callNextHandler = () => {
    setPopup(true);
  };

  const editButtonHandler = () => {
    dispatch(calendarPageIndex(0));
    props.history.push("/appointmentscheduler");
    window.location.reload();
  }

  interface GetAvailabilityData {
    availabilities: RawAvailablity[];
    isPreferences: boolean;
    hasSlaAvailability: boolean;
    earliestAvailabilityType: string;
    title: string;
    statusCode: number;
  }

  let referenceNumber = "";
  let operationKey = "";
  let workOrderId = "";

  const getNotesCreationPayload = (text: string) => {
    const notesCreationPayload = {
      noteTypeId: t("Other_note_value"),
      text: text,
    };
    return notesCreationPayload;
  };

  function AddNote(getNotesCreationPayload: () => { noteTypeId: string; text: string; }, jobNumber: string) {
    const createdNotesPayload = getNotesCreationPayload();
    const [serialNumber, sequenceNumber] = jobNumber.split("/");
    const createNote = api.postNoteForWorkorder(
      serialNumber,
      sequenceNumber,
      createdNotesPayload
    );
  }

  const addWaitingNotesandRedirect = (Data: any) => {
  if (Data[0]?.status === "rejected") {
    AddNote(() => getNotesCreationPayload(Data[0]?.reason?.title === 'Aborted' || Data[0]?.reason?.status === 499 ? t("Dual_WO_Notes_Timeout") : t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
  }
  else if (Data[0]?.value?.statusCode && Data[0]?.value?.statusCode !== 200 && Data[0]?.value?.statusCode !== 404) {
    AddNote(() => getNotesCreationPayload(t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
  }
  if (Data[1]?.status === "rejected") {
    AddNote(() => getNotesCreationPayload(Data[1]?.reason?.title === 'Aborted' || Data[1]?.reason?.status === 499 ? t("Dual_WO_Notes_Timeout") : t("Notes_For_Failed_To_Retrieve")), workOrderObject?.associatedWorkOrdersJobNumber);
  }
  else if (Data[1]?.value?.statusCode && Data[1]?.value?.statusCode !== 200 && Data[1]?.value?.statusCode !== 404) {
    AddNote(() => getNotesCreationPayload(t("Notes_For_Failed_To_Retrieve")), workOrderObject?.associatedWorkOrdersJobNumber);
  }
  dispatch(setTriageRepair(false));
}

  const getCaseActivitiesResponse = useCallback(async (caseIdentifierValue: string) => {
    if (caseIdentifierValue && caseIdentifierValue.trim() !== "") {
      const caseActivitiesResponse = await api.getDMCCaseData(caseIdentifierValue);
      setcaseActivities(caseActivitiesResponse);
      dispatch({ type: CASE_ACTIVITIES_DATA, payload: caseActivitiesResponse });
    }
  }, [caseActivities?.caseReferenceNumber]);

  const GetAppointmentAvailability = async () => {
    setIsLoading(true);
    const noOftimeOutForAppointment = Number(configuration_Timeout) * 1000; //60 seconds configured in App config
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), noOftimeOutForAppointment);
    dispatch(userChosenPropertyType(userGetRepairDataValue?.area));

    if (calendarPageIndexValue === 1) {
      workOrderId = dmcWOObject?.id;
      referenceNumber = workOrderObject?.associatedWorkOrdersJobNumber;
    }
    else {
      workOrderId = workOrderObject?.id ?? repairHistoryData?.repairHistoryWorkOrderID;
      referenceNumber = workOrderObject?.jobNo ?? repairHistoryData?.RepairHistoryrepairReference;
    }
    if (isNullOrUndefined(repairHistoryData?.RepairHistoryContractor)) { dispatch(getContractorName(workOrderObject?.contractorName)) }
    operationKey = uuid();
    let mainWorkOrderAvailablityData = originalRepairAppointmentValue;
    let dmcAvailabliltyData = dmcRepairAppointmentValue;
    let totalResponse: any
    if (!isNullOrUndefined(workOrderObject) && !isNullOrUndefined(dmcWOObject)
      && !isOriginalRepairAppointmentWillNotBeCreated && !isDmcRepairAppointmentWillNotBeCreated
      && isNullOrUndefined(originalRepairAppointmentValue)
      && isNullOrUndefined(dmcRepairAppointmentValue)) {
      try {
        await Promise.allSettled([
          getAvailabilityForAppointment(
            workOrderId,
            referenceNumber,
            operationKey,
            determinedcontractordetails?.name,
            workOrderObject?.workProgramme || repairHistoryData?.repairHistoryWorkProgramme || "",
            controller.signal
          ),
          getAvailabilityForAppointment(
            dmcWOObject?.id,
            workOrderObject?.associatedWorkOrdersJobNumber,
            operationKey,
            dmcWOObject?.contractorName,
            dmcWOObject?.workProgramme || "",
            controller.signal
          )
        ]).then((res: any) => {
          totalResponse = res
          if (res[0]?.value?.availabilities?.length > 0 && res[1]?.value?.availabilities?.length > 0) {
            mainWorkOrderAvailablityData = res[0]?.value;
            dmcAvailabliltyData = res[1]?.value;
          }
          else if ((res[0]?.status === "rejected" && res[1]?.value?.availabilities?.length > 0) || (res[0]?.value?.statusCode && res[1]?.value?.availabilities?.length > 0)) {
            dmcAvailabliltyData = res[1]?.value;
            dispatch(calendarPageIndex(1));
            dispatch(originalRepairAppointmentWillNotBeCreated(true));
            props.history.push("/appointmentscheduler");
          }
          else if ((res[0]?.value?.availabilities?.length > 0 && res[1]?.status === "rejected") || (res[0]?.value?.availabilities?.length > 0 && res[1]?.value?.statusCode)) {
            mainWorkOrderAvailablityData = res[0]?.value;
            dispatch(dmcRepairAppointmentWillNotBeCreated(true));
          }
          else {
            props.history.push("/repairFinalDetails");
          }
        });
      } catch (err: any) {
        clearTimeout(timeout);
        setIsLoading(false);
        console.log(err)
        if (err.title === 'Aborted' || err.status === 499) {
          addWaitingNotesandRedirect(totalResponse);
        }
        if (!isNullOrUndefined(dmcWOObject)) {
          props.history.push("/repairFinalDetails");
        }
        else {
          props.history.push("/customer360View");
        }
      }
    }
    else if (isOriginalRepairAppointmentWillNotBeCreated && !isNullOrUndefined(dmcWOObject)
      && calendarPageIndexValue === 1 && isNullOrUndefined(dmcRepairAppointmentValue)) {
      try {
        dmcAvailabliltyData = await getAvailabilityForAppointment(dmcWOObject?.id, workOrderObject?.associatedWorkOrdersJobNumber, operationKey, dmcWOObject?.contractorName, dmcWOObject?.workProgramme || "",
 controller.signal)
      } catch (err: any) {
        clearTimeout(timeout);
        setIsLoading(false);
        console.log(err)
        AddNote(() => getNotesCreationPayload(err.title === 'Aborted' || err.status === 499 ? t("Dual_WO_Notes_Timeout") : t("Notes_For_Failed_To_Retrieve")), workOrderObject?.associatedWorkOrdersJobNumber);
      }
      if (dmcAvailabliltyData?.statusCode === 404) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Not_Availbility")), workOrderObject?.associatedWorkOrdersJobNumber);
      }
      else if (dmcAvailabliltyData?.statusCode && dmcAvailabliltyData?.statusCode !== 200) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Failed_To_Retrieve")), workOrderObject?.associatedWorkOrdersJobNumber);
      }
    }
    else if (isDmcRepairAppointmentWillNotBeCreated && !isNullOrUndefined(workOrderObject)
      && calendarPageIndexValue === 0 && isNullOrUndefined(originalRepairAppointmentValue)) {
      try {
        mainWorkOrderAvailablityData = await getAvailabilityForAppointment(workOrderId, referenceNumber, operationKey, determinedcontractordetails?.name,workOrderObject?.workProgramme  || repairHistoryData?.repairHistoryWorkProgramme || "",
 controller.signal)
      } catch (err: any) {
        clearTimeout(timeout);
        setIsLoading(false);
        console.log(err)
        AddNote(() => getNotesCreationPayload(err.title === 'Aborted' || err.status === 499 ? t("Dual_WO_Notes_Timeout") : t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
      }
      if (mainWorkOrderAvailablityData?.statusCode === 404) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Not_Availbility")), referenceNumber || workOrderObject?.jobNo);
      }
      else if (mainWorkOrderAvailablityData?.statusCode && mainWorkOrderAvailablityData?.statusCode !== 200) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
      }
    }
    else { // Adding to call for single wo calendar
      if (isNullOrUndefined(originalRepairAppointmentValue) && !isOriginalRepairAppointmentWillNotBeCreated) {
        try {
          mainWorkOrderAvailablityData = await getAvailabilityForAppointment(
            workOrderId,
            referenceNumber,
            operationKey,
            isNullOrUndefined(workOrderObject) ? repairHistoryData?.RepairHistoryContractor : determinedcontractordetails?.name, workOrderObject?.workProgramme  || repairHistoryData?.repairHistoryWorkProgramme || "",controller.signal);
        } catch (err: any) {
          clearTimeout(timeout);
          console.log(err)
          setIsLoading(false);
          AddNote(() => getNotesCreationPayload(err.title === 'Aborted' || err.status === 499 ? t("Dual_WO_Notes_Timeout") : t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
        }
        if (mainWorkOrderAvailablityData?.statusCode === 404) {
          AddNote(() => getNotesCreationPayload(t("Notes_For_Not_Availbility")), referenceNumber || workOrderObject?.jobNo);
        }
        else if (mainWorkOrderAvailablityData?.statusCode && mainWorkOrderAvailablityData?.statusCode !== 200) {
          AddNote(() => getNotesCreationPayload(t("Notes_For_Failed_To_Retrieve")), referenceNumber || workOrderObject?.jobNo);
        }
      }
    }
    clearTimeout(timeout);
    dispatch(originalRepairAppointmentData(mainWorkOrderAvailablityData));
    dispatch(dmcRepairAppointmentData(dmcAvailabliltyData));
    let isFlowCompleted = false;
    let payload: GetAvailabilityData;
    if (mainWorkOrderAvailablityData && calendarPageIndexValue !== 1) {
      payload = mainWorkOrderAvailablityData
    }
    else {
      payload = dmcAvailabliltyData;
    }
    if (!isFlowCompleted) {
      const data = payload?.availabilities;
      const dataIsPreference = payload?.isPreferences;
      if (!isNullOrUndefined(repairHistoryData) && repairHistoryData?.repairHistoryOperation === "RescheduleAppointment") {
        isRescheduleAppointment = true;
      }
      dispatch(saveAvailabilityResponse(data));
      dispatch(getReferenceNumber(referenceNumber));
      dispatch(getPrefferenceNumber(dataIsPreference));

      if (calendarPageIndexValue !== 1) {
        setTrack(Number(calenderTrackValue))
        tableActive(calenderIndexValue[0], calenderIndexValue[1], "data");
      }
      else if (calendarPageIndexValue === 1) {
        setTrack(Number(dmcCalenderTrackNumberValue))
        tableActive(dmcCalenderIndexValue[0], dmcCalenderIndexValue[1], "data");
      }
      if (totalResponse?.[0]?.status === "rejected" || totalResponse?.[1]?.status === "rejected" || (totalResponse?.[0]?.value?.statusCode && totalResponse?.[0]?.value?.statusCode !== 200) || (totalResponse?.[1]?.value?.statusCode && totalResponse?.[1]?.value?.statusCode !== 200)) {
        addWaitingNotesandRedirect(totalResponse);
      }
      if (totalResponse?.[0]?.value?.statusCode === 404) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Not_Availbility")), referenceNumber || workOrderObject?.jobNo);
      }
      if (totalResponse?.[1]?.value?.statusCode === 404) {
        AddNote(() => getNotesCreationPayload(t("Notes_For_Not_Availbility")), workOrderObject?.associatedWorkOrdersJobNumber);
      }
      if (data !== undefined && data?.length > 0) {
        isFlowCompleted = true;
        setIsLoading(false);
        setTimeout(() => {
          if (isDMCEnabledtoggleValue) {
            getCaseActivitiesResponse(caseIdentifiers);
          }
          dispatch(setWorkOrderApiFailureMessage(false));
          dispatch(comingFromRepairJourneySuccess(true));
          props.history.push("/appointmentscheduler");
          return;
        }, 3000);
      }
      else if (payload?.statusCode !== 200 && !isRescheduleAppointment) {
        isFlowCompleted = true;
        setIsLoading(false);
        dispatch(setTriageRepair(false));
        dispatch(setWorkOrderApiFailureMessage(false));
        dispatch(comingFromRepairJourneySuccess(true));
        if (!isNullOrUndefined(dmcWOObject)) {
          props.history.push("/repairFinalDetails");
        }
        else {
          props.history.push("/customer360View");
        }
      } else {
        dispatch(showFooter(true));
        if (!isNullOrUndefined(dmcWOObject)) {
          props.history.push("/repairFinalDetails");
        }
        else {
          props.history.push("/customer360View");
        }
      }
    }
  };

  const tConv24 = (time24: string) => {
    let ts = time24;
    let H = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? +h : h;
    let ampm = H < 12 ? "AM" : "PM";
    ts = h + ampm;
    return ts;
  };
  const getFirstHighCapacitySlotDate = (availabilities: any[]): string | null => {
    const highCapacitySlot = availabilities
      .flatMap((availability) => availability.slots)
      .find((slot) => slot.capacity === "High");

    return highCapacitySlot ? highCapacitySlot.date : null;
  };
  const createAppointmentonFinalStep = async () => {
    if (!isNullOrUndefined(repairHistoryData) && repairHistoryData?.repairHistoryOperation === "RescheduleAppointment") {
      const rescheduleAppointmentParam: RescheduleAppointmentModel = {
        status: "RESCHEDULE",
        reasonCode: "RESCHEDULE_APPOINTMENT",
        remarks: "",
        isPreferred: isPreferenceAppointment,
        jobNumber: referenceNumberCode,
        appointmentFromDate: selectedSlot.date,
        appointmentToDate: selectedSlot.date,
        externalCreateDateTime: selectedSlot.date,
        availabilityType: selectedSlot.availabilityType,
        isInsideSla: selectedSlot.insideSla,
        contractorSiteCode: repairHistoryData.repairHistoryContractorSitesIdentifier
      }
      setIsRescheduleAppointment(true);
      setErrorForRescheduleApiDown(false)
      setIsNextLoading(true);
      setButtonDisable(true);
      if (!isNullOrUndefined(repairHistoryData) && repairHistoryData?.repairHistoryWorkOrderID != undefined) {
        workOrderId = repairHistoryData.repairHistoryWorkOrderID;
      }
      else if (!isNullOrUndefined(workOrderObject)) {
        workOrderId = workOrderObject.id;
      }
      try {
        const result = await patchAppointment(
          workOrderId,
          rescheduleAppointmentParam
        );

        if (result && !result.appointmentId) {
          setErrorForRescheduleApiDown(true)
          setErrorMessage(t("Reschedule_ApiFailError"))
          if (result?.status === 412) {
            let message = t("SSR071");
            message = message.replace("{0}", name).replace("{1}", phone);
            setErrorMessage(message);
          }
        }
        else {
          setErrorForRescheduleApiDown(false)
          dispatch(saveSelectedSlotDate(selectedSlot));
          dispatch(setTriageRepair(false));
          if (!isNullOrUndefined(dmcWOObject)) {
            history.push("/repairFinalDetails");
          }
          else {
            history.push("/customer360View");
          }
        }
      } catch (e) {
        console.log("Reschedule Appointment", e);
        dispatch(showFooter(true));
        dispatch(savingCalenderIndex([]));
        dispatch(savingcalenderTrackValue(""));
        dispatch(savingDmcCalenderIndex([]))
        dispatch(savingDmcCalenderTrackValue(""))
        props.history.push({
          pathname: '/repairJourneyErrorPage',
          state: { message: 'Reschedule_Api_Error' }
        });
      }
    } else {
      let createOriginalRepairAppointmentParams = new CreateAppointmentParams();
      let createDmcRepairAppointmentParams = new CreateAppointmentParams();

      if (!isNullOrUndefined(originalRepairSelectedSlotValue)) {
        createOriginalRepairAppointmentParams = {
          isPreferences: isPreferenceAppointment,
          jobNumber: workOrderObject?.jobNo ?? repairHistoryData?.RepairHistoryrepairReference,
          diaryCode: originalRepairSelectedSlotValue?.availabilityType,
          appointmentFromDate: originalRepairSelectedSlotValue?.date,
          availabilityType: originalRepairSelectedSlotValue?.availabilityType,
          isInsideSla: originalRepairSelectedSlotValue?.insideSla,
          reasonCode: "NEW_APPOINTMENT",
          remarks: "",
          appointmentToDate: originalRepairSelectedSlotValue?.date,
          externalCreateDateTime: originalRepairSelectedSlotValue?.date,
          externalReferenceId: "",
          metadata: originalRepairSelectedSlotValue?.metadata
        };
      }
      if (!isDmcRepairAppointmentWillNotBeCreated && !isNullOrUndefined(dmcRepairSelectedSlotValue)) {
        createDmcRepairAppointmentParams = {
          isPreferences: isPreferenceAppointment,
          jobNumber: workOrderObject?.associatedWorkOrdersJobNumber,
          diaryCode: selectedSlot.availabilityType,
          appointmentFromDate: selectedSlot.date,
          availabilityType: selectedSlot.availabilityType,
          isInsideSla: selectedSlot.insideSla,
          reasonCode: "NEW_APPOINTMENT",
          remarks: "",
          appointmentToDate: selectedSlot.date,
          externalCreateDateTime: selectedSlot.date,
          externalReferenceId: "",
          metadata: selectedSlot.metadata
        };
      }
      setIsNextLoading(true);
      setButtonDisable(true);
      if (!isNullOrUndefined(repairHistoryData) && repairHistoryData?.repairHistoryWorkOrderID !== undefined) {
        workOrderId = repairHistoryData.repairHistoryWorkOrderID;
      }
      else if (!isNullOrUndefined(workOrderObject)) {
        workOrderId = workOrderObject.id;
      }
      try {
        let dmcResult: any = null;
        let originalResult: any = null;
        let result = null;
        if (!isNullOrUndefined(originalRepairSelectedSlotValue) && !isNullOrUndefined(dmcRepairSelectedSlotValue)) {
          [originalResult, dmcResult] = await Promise.allSettled([
            postAppointment(workOrderObject?.id ?? repairHistoryData?.repairHistoryWorkOrderID,
              createOriginalRepairAppointmentParams, operationKey,determinedcontractordetails?.name, workOrderObject?.workProgramme  || repairHistoryData?.repairHistoryWorkProgramme || ""),
            postAppointment(dmcWOObject?.id, createDmcRepairAppointmentParams
              , operationKey, dmcWOObject?.contractorName,dmcWOObject?.workProgramme || "")
          ]);
          if (isNullOrUndefined(originalResult?.value?.appointmentId)) {
            AddNote(() => getNotesCreationPayload(`${t("Notes_For_Failed_Booking")}`), workOrderObject?.jobNo);
          }
          if (isNullOrUndefined(dmcResult?.value?.appointmentId)) {
            AddNote(() => getNotesCreationPayload(`${t("Notes_For_Failed_Booking")}`), workOrderObject?.associatedWorkOrdersJobNumber,);
          }
        }
        else if (!isNullOrUndefined(dmcRepairSelectedSlotValue) && isNullOrUndefined(originalRepairSelectedSlotValue)) {
          dmcResult = await postAppointment(dmcWOObject?.id, createDmcRepairAppointmentParams
            , operationKey, dmcWOObject?.contractorName,
          dmcWOObject?.workProgramme || "");
          if (isNullOrUndefined(dmcResult?.appointmentId)) {
            AddNote(() => getNotesCreationPayload(`${t("Notes_For_Failed_Booking")}`), workOrderObject?.associatedWorkOrdersJobNumber,);
          }
        }
        else {
          result = await postAppointment(
            workOrderObject?.id ?? repairHistoryData?.repairHistoryWorkOrderID,
            createOriginalRepairAppointmentParams,
            operationKey,
            isNullOrUndefined(workOrderObject) ? repairHistoryData?.RepairHistoryContractor
              : determinedcontractordetails?.name,
            workOrderObject?.workProgramme  || repairHistoryData?.repairHistoryWorkProgramme || ""
          );
          if (isNullOrUndefined(result?.appointmentId)) {
            AddNote(() => getNotesCreationPayload(`${t("Notes_For_Failed_Booking")}`), workOrderObject?.jobNo);
          }
        }
        //DMC changes
        if (caseActivities != null && !isNullOrUndefined(caseActivities?.caseReferenceNumber && isDMCEnabledtoggleValue)) {
          const firstAvailableDate = getFirstHighCapacitySlotDate(schedules?.availabilities);
          if (firstAvailableDate) {
            const firstAvailableDateObj = new Date(firstAvailableDate);
            const seventhDayDate = new Date();
            seventhDayDate.setDate(seventhDayDate.getDate() + 6);
            const selectedSlotDateObj = new Date(selectedSlot.date);
            if (firstAvailableDateObj.toISOString() > seventhDayDate.toISOString()) {
              reasonOutsideSla = t("reasonOutsideSlaContractor");
            } else if (firstAvailableDateObj.toISOString() <= seventhDayDate.toISOString() && selectedSlotDateObj.toISOString() > seventhDayDate.toISOString()) {
              reasonOutsideSla = t("reasonOutsideSlaResident");
            }
            else {
              reasonOutsideSla = "";
            }
          }
          updateCaseActivities();
        }
        if (!isNullOrUndefined(dmcWOObject) && !isDmcRepairAppointmentWillNotBeCreated) {
          if (!isNullOrUndefined(originalResult?.value?.appointmentId)) {
            dispatch(originalRepairSelectedSlotData(originalRepairSelectedSlotValue));
          }
          else {
            dispatch(originalRepairSelectedSlotData(null));
          }
          if (!isNullOrUndefined(dmcResult?.value?.appointmentId)) {
            dispatch(dmcRepairSelectedSlotData(selectedSlot));
          }
          else if (!isNullOrUndefined(dmcRepairSelectedSlotValue) && isNullOrUndefined(originalRepairSelectedSlotValue) && dmcResult?.appointmentId) {
            dispatch(dmcRepairSelectedSlotData(selectedSlot));
          }
          else {
            dispatch(dmcRepairSelectedSlotData(null));
          }
          dispatch(setTriageRepair(false));
          setIsNextLoading(false);
          setButtonDisable(false);
          dispatch(savingDmcCalenderIndex([]))
          dispatch(savingDmcCalenderTrackValue(""))
          dispatch(savingCalenderIndex([]));
          dispatch(savingcalenderTrackValue(""));
        }
        else if (!isNullOrUndefined(result?.appointmentId)) {
          dispatch(saveSelectedSlotDate(selectedSlot));
          dispatch(originalRepairSelectedSlotData(selectedSlot));
          dispatch(setTriageRepair(false));
          dispatch(savingCalenderIndex([]));
          dispatch(savingcalenderTrackValue(""));
          dispatch(savingDmcCalenderIndex([]));
          dispatch(savingDmcCalenderTrackValue(""));
        }
        else {
          dispatch(saveSelectedSlotDate(null));
          dispatch(originalRepairSelectedSlotData(null));
          dispatch(setTriageRepair(false));
          dispatch(savingCalenderIndex([]));
          dispatch(savingcalenderTrackValue(""));
          dispatch(savingDmcCalenderIndex([]));
          dispatch(savingDmcCalenderTrackValue(""));
        }
        if (!isNullOrUndefined(dmcWOObject)) {
          props.history.push("/repairFinalDetails");
        }
        else {
          props.history.push("/customer360View");
        }
      } catch (e) {
        console.log("createAppointment", e);
        dispatch(savingCalenderIndex([]));
        dispatch(savingcalenderTrackValue(""));
        dispatch(savingDmcCalenderIndex([]))
        dispatch(savingDmcCalenderTrackValue(""))
        props.history.push("/genericerror");
        const timerId = setTimeout(() => {
          props.history.push("/genericerror");
        }, 1000);
      }
    }
  };
  const updateCaseActivities = async () => {
    var caseTypeActionDetails = new CaseActionItem();
    caseTypeActionDetails.type = caseActivities?.activities[0]?.type;
    caseTypeActionDetails.identifiers.caseIdentifier =
      caseIdentifiers;
    caseTypeActionDetails.identifiers.actionIdentifier =
      caseActivities?.activities[0]?.activityIdentifiers[0];
    caseTypeActionDetails.metaData = [
      { key: "appointmentDate", value: selectedSlot.date },
      { key: "appointmentWithinSla", value: selectedSlot.insideSla ? "Yes" : "No" },
      { key: "reasonOutsideSla", value: reasonOutsideSla },
      { key: "activitySubType", value: caseActivities?.activities[0]?.subType },
      { key: "status", value: "complete" }
    ];

    try {
      await api.UpdateAnAction(
        caseIdentifiers,
        caseActivities?.activities[0]?.activityIdentifiers,
        caseTypeActionDetails
      );
    } catch (e) {
    } finally {
    }
  };
  const exitButtonHandler = () => {
    dispatch(savingCalenderIndex([]));
    dispatch(savingcalenderTrackValue(""));
    dispatch(savingDmcCalenderIndex([]))
    dispatch(savingDmcCalenderTrackValue(""))
    if (isUndefinedNullOrEmpty(loggedInStatus)) {
      props.history.push("/startpage")
    }
    else {
      props.history.push("/customer360View")
    }
  };

  const popupContinueButtonHandler = () => {
    dispatch(setTriageRepair(false));
    if (!isNullOrUndefined(dmcWOObject)) {
      if (isDmcRepairAppointmentWillNotBeCreated || calendarPageIndexValue === 1) {
        dispatch(savingDmcCalenderIndex([]))
        dispatch(savingDmcCalenderTrackValue(""))
        dispatch(dmcRepairSelectedSlotData(null));
        props.history.push("/repairFinalDetails");
      }
      else {
        dispatch(savingCalenderIndex([]));
        dispatch(savingcalenderTrackValue(""));
        dispatch(originalRepairSelectedSlotData(null));
        dispatch(calendarPageIndex(1));
        props.history.push("/appointmentscheduler");
        window.location.reload();
      }
    }
    else {
      props.history.push("/customer360View");
    }
  }

  const handleSlotSelect = (start: any, end: any, availabilityTypeLabel: any, date: any, insideSla: any, availabilityType: any, schedules: any, scheduleIndex: number, dateIndex: number) => {
    setError("");
    setButtonDisable(false);
    setSelectedSlot({
      start,
      end,
      availabilityTypeLabel,
      date,
      insideSla,
      availabilityType,
      metadata: schedules.availabilities[scheduleIndex].slots[track + dateIndex].metadata
    });
    setDispatchSelectedSlot({
      start,
      end,
      availabilityTypeLabel,
      date,
      insideSla,
      availabilityType,
      metadata: schedules.availabilities[scheduleIndex].slots[track + dateIndex].metadata,
      track
    });
    tableActive(dateIndex, scheduleIndex, "setSelectedSlot" + dateIndex + scheduleIndex);
  };

  const associatedWorkOrdersIdentifier = workOrderObject?.associatedWorkOrdersIdentifier ?? userGetRepairDataValue?.associatedWorkOrdersIdentifier;
  const isSelectedSlotVisible = !isNullOrUndefined(associatedWorkOrdersIdentifier) ? ((!isNullOrUndefined(originalRepairSelectedSlotValue)
    && calendarPageIndexValue !== 1) || (calendarPageIndexValue === 1 && (!isNullOrUndefined(dmcRepairSelectedSlotValue)
      || !isOriginalRepairAppointmentWillNotBeCreated))) : false;

  return (
    <>
      <HeaderJourney></HeaderJourney>
      <div className="container-fluid parent-footer p-0">
        {isRescheduleApiDown ? (
          <>
            <div className="padding-repair">

              <div className="gen-error">
                <div className="error" role="alert" id="repair-asset-alert">
                  <Message className="warning-msg">
                    {errorMessage}
                  </Message>

                  <div
                    className="flex justify-between items-center pb-4 md:pb-8 mt-perc"
                    id="repair-exit-btn"
                  >
                    <div className="flex justify-between items-center">
                      <BackModal
                        id="reploc-backmodal"
                        back={callReturnToRepairPageHandler}
                        btn_msg="return_case_button"
                      />
                      <ExitModal
                        id="repairproperty-exitmodal"
                        exit={exitButtonHandler}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="padding-repair mt-2">
            <div id="Cal-main-div" className="header_font_size mt-2 mb-2_5">
              <div className="hunderd100">{isRescheduleAppointment ? t("Reschedule_Appointment_Heading") : calendarPageIndexValue === 1
                ? t("Dmc_Calender_Msg") : t("SSR062")}</div>
              <div>
                <strong>
                  {calendarPageIndexValue === 1
                    ? t("damp_Mould_Check") : workOrderObject?.repairReason || userGetRepairDataValue?.repairReason}
                </strong>
              </div>
            </div>
            {isSelectedSlotVisible &&
              <div>
                <div className="hr-line"></div>
                <div className="appointment-size"><b>{t("Selected_appointment")}</b> </div>
                {!isOriginalRepairAppointmentWillNotBeCreated &&
                  <div className="tab-space appointment-size">
                    <b>{workOrderObject?.repairReason || userGetRepairDataValue?.repairReason}</b>
                    <span style={{ marginLeft: "8px" }}>
                      {getNoSuitableSelectedSlot() && isNullOrUndefined(originalRepairSelectedSlotValue)
                        ? "No appointment selected"
                        : formatDateWithFullMonthWeekInLetters(new Date(originalRepairSelectedSlotValue?.date).toDateString())
                        + ' (' + originalRepairSelectedSlotValue?.availabilityTypeLabel + ' '
                        + (moment(originalRepairSelectedSlotValue?.start, ["HH.mm"]).format("hh:mm a")
                          + '-' + moment(originalRepairSelectedSlotValue?.end, ["HH.mm"]).format("hh:mm a")) + ')'}
                    </span>
                    {calendarPageIndexValue === 1 && <button className="text-teal ml-1 Edit_button" onClick={editButtonHandler}>Edit</button>}
                  </div>
                }
                {(!isNullOrUndefined(dmcRepairSelectedSlotValue) && calendarPageIndexValue === 1) && <div className="tab-space appointment-size pb-2-border-resp">
                  <b>{t("Inspect_DMC")}</b>
                  <span style={{ marginLeft: "8px" }}>
                    {formatDateWithFullMonthWeekInLetters(new Date(dmcRepairSelectedSlotValue?.date).toDateString())
                      + ' (' + dmcRepairSelectedSlotValue?.availabilityTypeLabel + ' '
                      + (moment(dmcRepairSelectedSlotValue?.start, ["HH.mm"]).format("hh:mm a") + '-'
                        + moment(dmcRepairSelectedSlotValue?.end, ["HH.mm"]).format("hh:mm a")) + ')'}
                    </span>
                </div>}
                <div className="hr-line"></div>
              </div>}

            {/* Displaying repair reason and sub-heading here */}

            {error && (
              <Message className="warning-msg">
                {error}
              </Message>
            )}
            {isLoading ? (
              <div className="apScheduler" style={{ minHeight: '30rem' }}>
                <div className="loader-message" style={!isMobile ? { top: '10%' } : { width: '96%' }}>
                  {t("DMC_Calendar_Loader")}
                  <div className="loader-spinner-container" style={isMobile ? { marginTop: '10%' } : { marginTop: '8%' }}>
                    <Loader
                      type="ThreeDots"
                      color="#00BFFF"
                      height={50}
                      width={50}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {schedules.availabilities && (
                  <div className="apScheduler">
                    <div className="flex next-prev-pad justify-between items-center pb-2 md:pb-8 space-right">
                      <div className={(!isMobileDevice ? 'padding-left16' : '')}>
                        {track === 0 ? (
                          <a></a>
                        ) : (
                          <a
                            className="text-teal mouse-pointer"
                            onClick={() => changeRange(true)}
                            data-testid="previousButton"
                          >
                            <i className="fas fa-chevron-left"></i>
                            {t("Previous")}
                          </a>
                        )}
                      </div>
                      <div className={(!isMobileDevice ? 'padding-right2' : '')}>
                        {track + range > schedules.availabilities[0].slots.length ? (
                          <a></a>
                        ) : (
                          <a
                            className="text-teal mouse-pointer"
                            onClick={() => changeRange(false)}
                            data-testid="nextButton"
                          >
                            {t("Next")}
                            <i className="fas fa-chevron-right"></i>
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="sc-wrapper">

                      {schedules.availabilities[0].slots.slice(track, track + range,)
                        .map(({ date, insideSla, metadata }: any, dateIndex: any) => {
                          const dateInfo = new Date(date);
                          const day = ('0' + dateInfo.getDate()).slice(-2);
                          const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(dateInfo);
                          const year = ('' + dateInfo.getFullYear()).slice(-2);
                          const formattedDate = `${day} ${month} ${year}`;
                          return (
                            <div className="sc-schedules">
                              <div className="sc-sched-date sc-mob-date margin-rt">
                                <p className="wd-2">
                                  <b>{formattedDate}</b>
                                </p>
                              </div>
                              <div className="align-schedule-timings wt1 mt-top row">
                                {schedules.availabilities.map(
                                  (
                                    {
                                      availabilityDetails: {
                                        start,
                                        end,
                                        availabilityTypeLabel,
                                        availabilityType,
                                      },
                                    }: any,
                                    scheduleIndex: any
                                  ) => {
                                    return schedules.availabilities[scheduleIndex]
                                      .slots[track + dateIndex].capacity ==
                                      "Not Available" ? (
                                      <div className="sc-sched-slots cal-btn disabled-p color_black error-span-remove margin-top">
                                        -
                                      </div>
                                    ) : (
                                      !isIPhone() ?
                                        <button
                                          onClick={() => {
                                            handleSlotSelect(start, end, availabilityTypeLabel, date, insideSla, availabilityType, schedules, scheduleIndex, dateIndex)
                                          }}
                                          className={calBackground(dateIndex, scheduleIndex)}
                                          data-testid={`setSelectedSlot` + dateIndex + scheduleIndex}
                                        >
                                          <p className="wd-1">{`${tConv24(start)} - ${tConv24(end)}`}</p>
                                        </button>
                                        :
                                        <button
                                          onTouchStart={() => {
                                            handleSlotSelect(start, end, availabilityTypeLabel, date, insideSla, availabilityType, schedules, scheduleIndex, dateIndex)
                                          }}
                                          className={calBackground(dateIndex, scheduleIndex)}
                                          data-testid={`setSelectedSlot` + dateIndex + scheduleIndex}
                                        >
                                          <p className="wd-1">{`${tConv24(start)} - ${tConv24(end)}`}</p>
                                        </button>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            )}

            <div className="row appointment-btn-grp footer-actionbtn mt-68 mb-30">
              <div className="col-md-6 mt-8">
                {isRescheduleAppointment && (
                  <Button
                    id="btn_returntorepair"
                    disabled={buttondisable}
                    onClick={callReturnToRepairPageHandler}
                    className="secondary-ghost-btn"
                  >
                    {t("return_to_repair_button")}
                  </Button>

                )}
              </div>
              {isMobileDevice ? (<div className="mt-8 no-suitable-apt-mobile">
                {!isRescheduleAppointment && !isPreferenceAppointment && (
                  <div className="text-end mt-8">
                    <a
                      id="btn_nosuitableappoinment"
                      data-testid="nosuitableappt"
                      className="secondary-ghost-btn"
                      onClick={callNextHandler}
                    >
                      {t("No_Suitable_Appointment")}
                    </a>
                  </div>
                )}
                {(!isNullOrUndefined(dmcWOObject)) ? (
                  <div className="text-end mt-2">
                    <Button
                      id="btn_bookappointment"
                      disabled={buttondisable}
                      onClick={callPageHandler || (calendarPageIndexValue === 1 && !selectedSlot?.date)}
                      className="primary-btn"
                    >
                      {t("continuen_button")}
                    </Button>
                  </div>
                ) : (
                  <div className="text-end mt-2">
                    <Button
                      id="btn_bookappointment"
                      disabled={buttondisable}
                      onClick={callPageHandler}
                      className="primary-btn"
                    >
                      {t("Book_Appointment")}
                    </Button>
                  </div>
                )}
              </div>) : (<div className="mt-8 no-suitable-apt">
                {!isRescheduleAppointment && !isPreferenceAppointment && (
                  <div className="text-end mt-8">
                    <a
                      id="btn_nosuitableappoinment"
                      data-testid="nosuitableappt"
                      className="secondary-ghost-btn"
                      onClick={callNextHandler}
                    >
                      {t("No_Suitable_Appointment")}
                    </a>
                  </div>
                )}
                {(!isNullOrUndefined(dmcWOObject)) ? (
                  <div className="text-end ml">
                    <Button
                      id="btn_bookappointment"
                      disabled={buttondisable}
                      onClick={callPageHandler}
                      className="primary-btn"
                    >
                      {t("continuen_button")}
                    </Button>
                  </div>
                ) : (
                  <div className="text-end ml">
                    <Button
                      id="btn_bookappointment"
                      disabled={buttondisable}
                      onClick={callPageHandlerForSingleWO}
                      className="primary-btn"
                    >
                      {t("Book_Appointment")}
                    </Button>
                  </div>
                )}
              </div>
              )}
            </div>
            <div>
              <span>
                {isNextLoading ? (
                  <div>
                    <Loader
                      type="ThreeDots"
                      color="#00BFFF"
                      height={50}
                      width={50}
                      timeout={5000}
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </span>
            </div>

          </div>
        )}
      </div>
      <Modal open={popup} cssClasses="modalPopUp">
        <div className="py-4 px-4">
          <div
            className="close"
            onClick={() => setPopup(false)}
            onKeyPress={() => setPopup(false)}
          >
            <h4>X</h4>
          </div>
          <h3>{t("SSR023")}</h3>
          <p className="mt-4">
            {t("suitable_appointment")}
          </p>

          <div className="row footer-actionbtn mt-68 mb-30">
            <div className="col-md-6 mt-8">
              <Button
                id="checkappointmentsbtn"
                onClick={() => setPopup(false)}
                className="secondary-ghost-btn"
              >
                {t("Check_Appointments_Button")}
              </Button>
            </div>
            <div className="col-md-6 text-end mt-8">
              <Button
                onClick={popupContinueButtonHandler}
                className="primary-btn"
                id="checkappointmentsbtnContinue"
              >
                {t("continuen_button")}
              </Button>
            </div>

          </div>

        </div>
      </Modal>
    </>
  );
};
export default AppointmentScheduler;